<template>
    <div>
        <template
            v-for="(year, yearIdx) in years.slice(0, 12)"
        >
            <h4
                class="mb-1"
                :class="yearIdx > 0 ? 'mt-1' : undefined" :key="'title' + yearIdx"
            >
                {{ year }}
            </h4>
            <div
                v-for="(month, monthIdx) in months.filter(item => item.month.substring(0,4) == year)"
                :key="'box' + yearIdx + monthIdx"
                style="background-color:rgba(115, 103, 240, 0.2)"
                class="mb-1 position-relative"
            >
                <div
                    @click="changeMonth(month.month)"
                    class="px-1 text-nowrap float-left text-white bg-primary mr-1"
                    :style="{
                        opacity: month.month !== months[months.length - 1].month ? 0.7 : 1,
                        'width': Math.min(Math.max((100 * month.cost / maxMonthCost), 0), 100) + '%',
                        'height': month.month === months[months.length - 1].month ? '15px' : '16px',
                        'font-weight': month.month === months[months.length - 1].month ? 'bold' : '',
                        'font-size': month.month === months[months.length - 1].month ? '11px' : '11px',
                        color: month.month === months[months.length - 1].month ? '' : '',
                        borderRadius: '2px',
                        cursor:'pointer'
                    }"
                >
                    {{ __getMonthShortString(month.month.substring(5, 7)) }}
                </div>
                <span
                    class="position-absolute"
                    style="height:15px;font-size:11px;border-radius: 2px;"
                    :style="{
                        right: '4px',
                        'font-weight': month.month == months[months.length - 1].month ? 'bold' : '',
                        color: theme === 'dark' ? '#d0d2d6' :(Math.min(Math.max((100 * month.cost / maxMonthCost), 0), 100) < 90 ? '#5e5873?' : '#fff')
                    }"
                >
                    {{ $_getDollar(month.cost).replace(' ','') }}
                </span>

                <div class="clearfix"></div>
            </div>
        </template>
    </div>
</template>

<script>
import useCommonData from '@/composables/useCommonData'
import useDashboard from '@/composables/useDashboard'
import { getCurrentInstance, computed, watch, inject } from '@vue/composition-api'
import useSelectMonth from '@/composables/useSelectMonth'
export default {
    setup (props, context) {
        const theme = inject('theme')
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const { __getMonthShortString } = useCommonData()
        const { getSummaryMonths } = useDashboard()
        const currentParams = computed(() => store.getters['$_dashboard/currentParams'])
        const [status, data] = getSummaryMonths(currentParams.value)
        /** computed */
        const months = computed(() => data.value.list.slice(-6))
        const years = computed(() => {
            return months.value.map(item => item.month.substring(0, 4)).filter((obj, pos, arr) => {
                return arr.indexOf(obj) === pos
            })
        })
        const maxMonthCost = computed(() => months.value.length ? Math.max.apply(null, months.value.map(item => item.cost)) : 0)
        const {
            handleSelectMonth
        } = useSelectMonth()
        const changeMonth = (month) => handleSelectMonth(month)
        watch(currentParams, (value, oldValue) => {
            getSummaryMonths(value)
        }, {
            deep: true
        })
        return {
            __getMonthShortString,
            theme,
            status,
            months,
            years,
            maxMonthCost,
            changeMonth
        }
    }
}
</script>
